export const API_URL = process.env.REACT_APP_API_ENDPOINT;
export const TABLE_HEADINGS = ['Name', 'Type', 'Brand', 'Availability'];
export const LIMIT = '15';
